import { useOrganizationInfo } from "@/shared/hooks/useOrganizationInfo";
import { cn } from "@/shared/utils/style.util";

type OrganizationInitialsProps = { className?: string };

const getInitial = (name: string | undefined): string => {
  if (!name) return "C";

  return name.trim()[0]?.toUpperCase() ?? "C";
};

export const OrganizationInitials = ({ className }: OrganizationInitialsProps) => {
  const { name } = useOrganizationInfo();
  const initial = getInitial(name);

  return (
    <div
      className={cn(
        "flex size-8 items-center justify-center rounded-md bg-sidebar-primary text-sm font-bold text-sidebar-primary-foreground",
        className,
      )}
    >
      {initial}
    </div>
  );
};

OrganizationInitials.displayName = "OrganizationInitials";
